import { IOrderTrackerState } from '../state';
import { AsyncActionState } from '@telstra-connect/standard-actions/async-action';
import { ActiveTabs } from './orders';
import { OrderListOriginalColumns, SelectedFiltersInitialValues } from './product-order-list';

export const initialState: Readonly<IOrderTrackerState> = Object.freeze({
    orderExpress: {
        status: AsyncActionState.NotStarted,
        data: {
            isLegacy: null,
        }
    },
    putServiceReferenceInt: {
        status: AsyncActionState.NotStarted,
      },
    summary: {
        status: AsyncActionState.NotStarted,
        data: {
            ordersTotal: 0,
            ordersAtRisk: 0,
            ordersDelayed: 0,
            ordersOnTrack: 0,
            ordersClosed: 0,
            isPartialResponse: null
        }
    },
    downloadStatus: {
        status: AsyncActionState.NotStarted,
    },
    tabState: {
        activeTab: ActiveTabs.Orders
    },
    activeOrders: {
        status: AsyncActionState.NotStarted,
        data: {
            orders: [],
            locationOrders: [],
            original_orders: [],
            isPartialResponse: null,
        },
        tabs: {
            orders: {
                sort: '',
                selectedColumns: ['number', 'name', 'ncp', 'yourReference', 'location', 'status', 'sitesComplete',
                    'estimatedDelivery', 'closedDate', 'requiredDelivery', 'projectManager', 'cidn', 'customerName'],
                paginationOrder: {
                    active: '',
                    pageSizeActive: 20,
                    paginationActive: 0,
                }
            },
            locations: {
                sort: '',
                selectedColumns: ['id', 'name', 'productType', 'productStatus', 'siteAddress',
                    'siteName', 'productEstimatedDelivery', 'productRequiredDelivery', 'upcomingAppointment',
                    'productClosedDate', 'number', 'ncp', 'yourReference', 'customerName', 'cidn', 'location',
                    'deliveryAddress', 'serviceId', 'billing'],
                paginationOrder: {
                    active: '',
                    pageSizeActive: 20,
                    paginationActive: 0,
                }
            }
        }
    },
    orderDetails: {
        status: AsyncActionState.NotStarted,
        data: {
            OrderSummary: null,
            ProductDetails: []
        }
    },
    orderDetailsNew: {
        status: AsyncActionState.NotStarted,
        data: null
    },
    orderInfo: {
        status: AsyncActionState.NotStarted,
        data: {
            status: '',
            amendStatus: '',
            orderClosedDate: '',
            requiredDate: '',
            estimatedDate: '',
            ncp: '',
            selectedProduct: null,
            selectedSummaryItem: null,
            selectedViewBy: '',
            summary: [],
            progress: [],
            substageContent: [],
            emptySubstageContent: [],
            substageCommentsContent: [],
            projectManager: '',
            yourReference: '',
            customerName: '',
            primaryContact: '',
            contractSignedDate: '',
            referenceOrders: [],
            fulfilmentVersion: null,
            suspendResumeContent: null,
            relatedRequestNumber: '',
            originalData: {
                status: '',
                amendStatus: '',
                orderClosedDate: '',
                requiredDate: '',
                estimatedDate: '',
                ncp: '',
                selectedProduct: null,
                selectedSummaryItem: null,
                selectedViewBy: '',
                summary: [],
                progress: [],
                substageContent: [],
                emptySubstageContent: [],
                substageCommentsContent: [],
                projectManager: '',
                yourReference: '',
                customerName: '',
                primaryContact: '',
                contractSignedDate: '',
                referenceOrders: [],
                fulfilmentVersion: null,
                suspendResumeContent: null,
                relatedRequestNumber: '',
            }
        },
        temp: {
            productName: '',
            productType: '',
            siteAddress: ''
        }
    },
    search: {
        orders: {
            searchString: '',
            original: {
                location: [],
                status: [],
                productName: [],
                dateRange: []
            },
            filters: {
                location: [],
                status: [],
                productName: [],
                dateRange: []
            }
        },
        orderDetailsSummary: {
            original: {
                status: []
            },
            filters: {
                status: []
            }
        }
    },
    activeIntOrdersV2: {
        status: AsyncActionState.NotStarted,
        data: {
            orders: [],
            locationOrders: [],
            original_orders: [],
            isPartialResponse: null,
        },
    },
    orderSearchV2: {
        orders: {
            searchString: '',
            original: {
                location: [],
                status: [],
                productName: [],
                siteAddress: [],
                dateRange: []
            },
            filters: {
                location: [],
                status: [],
                productName: [],
                siteAddress: [],
                dateRange: []
            }
        }
    },
    productListDownload: {
        status: AsyncActionState.NotStarted
    },
    productOrderList: {
        status: AsyncActionState.NotStarted,
        productList: null,
        selectedColumns: OrderListOriginalColumns,
        tableConfig: {
            currentPage: 1,
            pageSize: 10
        },
        filters: null,
        selectedFilters: SelectedFiltersInitialValues,
        searchText: '',
        sortParam: {
            sortBy: '',
            sortOrder: 'none'
        },
        hideFilterAction: true
    }
});
